import React from "react";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DataTable from "components/Tables/DataTable/DataTable";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import MDAlert from "components/MDAlert";
import useVehiclesTable from "hooks/fleet/useVehiclesTable";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";
import { Link } from "react-router-dom";
import { Icon } from "@mui/material";

export default function FleetSettingsPage() {
  const { columns, rows, loading, error, DeleteConfirmationDialog } = useVehiclesTable();

  const tableData = { columns, rows };

  return (
    <DashboardPage>
      <MDTypography variant="h4" fontWeight="medium" mb={3}>
        Fleet Settings
      </MDTypography>

      <MDBox>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <MDTypography variant="h6" fontWeight="medium">
            Vehicles
          </MDTypography>
          <MDButton
            component={Link}
            to="/fleet/vehicles/create"
            color="blue"
            size="small"
          >
            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
            &nbsp;Create Vehicle
          </MDButton>
        </MDBox>

        {loading && <TableSkeleton numberOfLines={10} />}

        {error && (
          <MDAlert color="error" mb={2}>
            {parseGraphQLError(error)}
          </MDAlert>
        )}

        {!loading && !error && <DataTable table={tableData} />}
      </MDBox>

      <DeleteConfirmationDialog />
    </DashboardPage>
  );
}
